import React from 'react';
import { ExternalLink } from 'lucide-react';

const NativeAd = ({ placement = 'article-end' }) => {
  // Mock native ad - would integrate with Taboola/Outbrain
  const mockAds = [
    {
      title: "10 Tech Gadgets That Will Change Your Life in 2026",
      image: "https://images.unsplash.com/photo-1550009158-9ebf69173e03?w=400",
      source: "TechLife"
    },
    {
      title: "The Future of Remote Work: Essential Tools You Need",
      image: "https://images.unsplash.com/photo-1593642632823-8f785ba67e45?w=400",
      source: "WorkTech"
    },
    {
      title: "AI Revolutionizes Home Security - See How",
      image: "https://images.unsplash.com/photo-1558002038-1055907df827?w=400",
      source: "SmartHome Today"
    }
  ];

  return (
    <div className="bg-[#0A0A0A] border border-neutral-800 rounded-lg p-6">
      <div className="flex items-center justify-between mb-4">
        <p className="text-xs font-mono uppercase tracking-wider text-neutral-600">
          You May Also Like
        </p>
        <p className="text-xs text-neutral-700">Sponsored</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {mockAds.map((ad, idx) => (
          <a
            key={idx}
            href="#"
            target="_blank"
            rel="noopener noreferrer sponsored"
            className="group"
          >
            <div className="aspect-video bg-neutral-900 rounded-lg overflow-hidden mb-2">
              <img
                src={ad.image}
                alt={ad.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
              />
            </div>
            <h4 className="text-white text-sm font-semibold mb-1 line-clamp-2 group-hover:text-cyan-400 transition-colors">
              {ad.title}
            </h4>
            <div className="flex items-center gap-2 text-xs text-neutral-600">
              <span>{ad.source}</span>
              <ExternalLink className="w-3 h-3" />
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default NativeAd;
